<div class="flex flex-row justify-center text-left gap-3 m-auto sm:w-3/4 md:w-3/4 lg:w-2/3 xl:w-1/2 3xl:w-1/3 z-9998 h-14">
    <app-cancel-button *ngIf="authorizeBack" (onClick)="location.back()" class="w-14 h-15"></app-cancel-button>
    <app-validate-button [text]="buttonText" (onClick)="onNext.emit()" [disabled]="!isValid" class="w-full"></app-validate-button>
</div>
